// extracted by mini-css-extract-plugin
export var brand = "_2l-9";
export var button = "_2l-0";
export var chevron = "_2l-v";
export var chevronButton = "_2l-w";
export var content = "_2l-n";
export var danger = "_2l-g";
export var dangerOutlined = "_2l-h";
export var dark = "_2l-l";
export var darkTheme = "_2l-c";
export var extraSmall = "_2l-4";
export var fullWidth = "_2l-8";
export var ghost = "_2l-d";
export var gray = "_2l-t";
export var icon = "_2l-p";
export var iconButton = "_2l-s";
export var iconButtonBorder = "_2l-x";
export var iconButtonBorderDark = "_2l-y";
export var iconButtonBorderLight = "_2l-z";
export var iconLeft = "_2l-q";
export var iconRight = "_2l-r";
export var large = "_2l-1";
export var light = "_2l-m";
export var medium = "_2l-2";
export var micro = "_2l-5";
export var nano = "_2l-7";
export var outlined = "_2l-k";
export var pending = "_2l-a";
export var primary = "_2l-i";
export var shadow = "_2l-o";
export var small = "_2l-3";
export var solidLight = "_2l-e";
export var solidLightBrand = "_2l-f";
export var spinner = "_2l-u";
export var transparent = "_2l-j";
export var warning = "_2l-b";
export var wideNano = "_2l-6";